<script lang="ts" setup>
import SpinnerInput from '@/components/steps/accessories/SpinnerInput.vue'
import formStore from '@/store/FormStore.ts'
import { computed, onMounted } from 'vue'
import { CharacteristicType } from '@/helper/Types.ts'
import { BackupHeater } from '@/services/models/implementations/BackupHeater.ts'
import { BackupHeaterCharacteristic } from '@/services/models/BackupHeaterCharacteristic.ts'

const props = defineProps<{
  integratedBackupHeater: BackupHeater
}>()

const maxSpinnerValue = computed(() => {
  const characteristic = props.integratedBackupHeater.getProductCharacteristic(CharacteristicType.BACKUP_HEATER) as BackupHeaterCharacteristic

  return characteristic.powerOutput
})

const powerOutputValue = computed({
  get: () => Number(formStore.data.powerOutputIntegratedBackupHeater) || maxSpinnerValue.value,
  set: (val: number) => (formStore.data.powerOutputIntegratedBackupHeater = val),
})

onMounted(() => {
  if (!formStore.data.powerOutputIntegratedBackupHeater) {
    formStore.data.powerOutputIntegratedBackupHeater = maxSpinnerValue.value
  }
})

</script>

<template>
  <div class="card">
    <div class="backup-heater-power-output__label">
      {{ $t('step_components.buh_power_output_label') }} :
    </div>
    <div class="backup-heater-power-output__spinner-row">
      <SpinnerInput
        id="power-output-backup-heater"
        v-model="powerOutputValue"
        :hide-controls-mobile="false"
        :min-val="0.5"
        :stepper="0.5"
        :max-val="maxSpinnerValue"
        :readonly-input="true"
      />
      <span class="backup-heater-power-output__max-input-text">
        {{ $t('step_components.buh_power_output_max_label', { maxInput: maxSpinnerValue }) }}*
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

:deep(.spinner__input) {
  @include media('<desktop') {
    width: rem-calc(50);
  }
}

.card {
  display: flex;
  padding: 0.75rem 1.25rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

  box-shadow: none;

  border-radius: 0.5rem;
  border: 1px solid $borderColor;

}

.backup-heater-power-output {
  &__label {
    color: $textColor50575C;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.125rem;
  }

  &__spinner-row {
    display: flex;
    align-items: center;
    gap: 8px;
    @include media('<desktop') {
      flex-direction: column;
    }
  }

  &__max-input-text {
    color: $textColor50575C;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.125rem;
  }
}

</style>
